/* eslint no-console: ["error", { allow: ["error"] }] */
document.addEventListener( 'DOMContentLoaded', () => {
  const toSvgElements = document.querySelectorAll( '.to-svg img' );
  const svgReplacementPromises = [];

  toSvgElements.forEach( ( img ) => {
    const imgSrc = img.getAttribute( 'src' );

    if ( imgSrc && imgSrc.endsWith( '.svg' ) ) {
      const promise = fetch( imgSrc )
        .then( ( response ) => response.text() )
        .then( ( data ) => {
          const parser = new window.DOMParser();
          const svgDoc = parser.parseFromString(
            data,
            'image/svg+xml'
          );
          const svgElement = svgDoc.querySelector( 'svg' );

          if ( svgElement ) {
            // Copy over any attributes from the img to the svg
            svgElement.setAttribute(
              'class',
              img.getAttribute( 'class' )
            );
            svgElement.setAttribute(
              'width',
              img.getAttribute( 'width' )
            );
            svgElement.setAttribute(
              'height',
              img.getAttribute( 'height' )
            );
            svgElement.setAttribute(
              'alt',
              img.getAttribute( 'alt' )
            );

            // Replace img with the inline svg
            img.parentNode.replaceChild( svgElement, img );
          }
        } )
        .catch( function ( error ) {
          console.error( 'Error fetching the SVG:', error );
        } );

      // Add the fetch promise to the array
      svgReplacementPromises.push( promise );
    }
  } );

  // Once all SVGs are replaced, run the tab functionality
  Promise.all( svgReplacementPromises ).then( () => {
    const sections = document.querySelectorAll( '.pillar-tabs' );

    sections.forEach( ( section ) => {
      const divTabOpeners = section.querySelectorAll( 'div.pillar-tab' );
      const gTabOpeners = section.querySelectorAll( 'g.pillar-tab' );
      const tabContents = section.querySelectorAll( '.pillar-content' );

      const clearActiveStates = () => {
        divTabOpeners.forEach( ( opener ) => {
          opener.classList.remove( 'active' );
        } );
        gTabOpeners.forEach( ( opener ) => {
          opener.classList.remove( 'active' );
        } );
        tabContents.forEach( ( content ) => {
          content.classList.remove( 'active' );
        } );
      };

      const activateTab = ( index ) => {
        tabContents[ index ].classList.add( 'active' );
      };

      divTabOpeners.forEach( ( opener, index ) => {
        opener.addEventListener( 'click', () => {
          clearActiveStates();
          opener.classList.add( 'active' );
          if ( gTabOpeners && gTabOpeners[ index ] ) {
            gTabOpeners[ index ].classList.add( 'active' );
          }
          activateTab( index );
        } );
      } );

      gTabOpeners.forEach( ( opener, index ) => {
        opener.addEventListener( 'click', () => {
          clearActiveStates();
          opener.classList.add( 'active' );
          divTabOpeners[ index ].classList.add( 'active' );
          activateTab( index );
        } );
      } );
    } );
  } );
} );



// WEBPACK FOOTER //
// ./scripts/pillar-tab.js